<template>
	<div id="DtuList" class="tableScope">
		<Confirm ref="confirm" @confirm="del"></Confirm>
		<edit-child-sys-device :selectChildSystem="stationId?true:false" @editSuccess="editSuccess" :type="'onlyName'" ref="editChildSysDevice"></edit-child-sys-device>
		<div class="table table-5x tra-fast posR bgContent" fillHeight="lastHeight,-.DtuListHeight">
			<Loading ref="Loading"></Loading>
			<div class="cb" v-show="pagination.total>0" >
				<div class="scrollHide tra-fast fL" :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*.7+stage.setting.system.autoColumnWidth[1]}" scrollFloatX="false" fillHeight="lastHeight,-.DtuListHeight">
					<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
						<!-- <div class="w4x"></div> -->
						<!-- <div :title="getLanguageStr('plant316','名称/序列号')">{{getLanguageStr('plant316','名称/序列号')}}</div> -->
						<div :class="{cMain:order.property=='device_sn'}" class="sequence" :title="getLanguageStr('word1784','名称/SN号')" @click="Order('device_sn')"><span>{{getLanguageStr('word1784','名称/SN号')}}</span>
							<span :sequence="order.property=='device_sn'? order.direction:''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.DtuListHeight" scroll="{'group':'a'}">
						<table>
							<thead class="head-token">
							<tr>
								<!-- <th class="w4x"></th> -->
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(plant,index) in list" :key="index">
								<td class="curP" @click.stop="view(plant)">
									<div :title="plant.name||getLanguageStr('word802','DTU')">{{plant.name||getLanguageStr('word802','DTU')}}</div>
									<div class="cSub" :title="plant.serialNumber ">
										{{plant.serialNumber}}
									</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="operate scrollHide" :class="{'operate-2x':stationId,'operate-3x':!stationId}" fillHeight="lastHeight,-.DtuListHeight" :mode="stage.setting.loc.operateMode" v-if="moreBtnFlag">
					<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
						<div class="cb vaM_E">
							<button class="fa fa-angle-double-right hover-c-main" :title="$t('cmd108',['点击展开/收起'])" @click="operateModeChange" type="button"></button>
							<span class="dpIB lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
							<!-- <button class="sizeS mr1x bdSub boxR cField pl05x pr05x hover-primary fR" type="button">{{getLanguageStr('all19','自定义列')}}</button> -->
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-.DtuListHeight" scroll="{'group':'a'}">
						<table>
							<thead class="head-token">
							<tr>
								<th></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(plant,index) in list" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-f-primary_E tra-fast_E vaM_E">
									<button v-if="!stationId" v-permissions="'A/B/A6'" permission-type="none" @click="viewPlant(plant)" :title="$t('plant_device2',['系统'])" type="button">
										<Icon name="link" class="ico"/>
									</button>
									<button type="button" @click="editDeviceInfo(plant)" :title="$t('cmd8',['编辑'])" v-permissions="'A/B/A9'" permission-type="none" v-if="doPermissions('A/B/A9',{targetCode:'A5',codeList:clone(plant.roleCode||roleCode)})">
										<Icon name="ico-edit-o" class="ico"/>
									</button>
									<button class="hover-c-error hover-f-error" type="button" @click="confirmDel(plant)" :title="$t('cmd9',['删除'])" v-permissions="'A/B/A10'" permission-type="none" v-if="doPermissions('A/B/A10',{targetCode:'A6',codeList:clone(plant.roleCode||roleCode)})">
										<Icon name="ico-recycle" class="ico"/>
									</button>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div scroll="{'axis':'x'}">
					<div class="tableSys head noSelect b cField bdLight-bottom"
						:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
						scrollFloatY="false">
						<div class="w10x taC" :title="getLanguageStr('word166','状态')">{{getLanguageStr('word166','状态')}}</div>
						<div :title="getLanguageStr(stationId?'word1785':'plant278','所属系统:所属电站')">{{getLanguageStr(stationId?'word1785':'plant278','所属系统:所属电站')}}</div>
						<div class="w14x sequence" :class="{cMain:order.property=='collection_time'}" :title="getLanguageStr('word1715','数据更新时间')" @click="Order('collection_time')">
							<span>{{getLanguageStr('word1715','数据更新时间')}}</span>
							<span :sequence="order.property=='collection_time'? order.direction:''"></span>
						</div>
					</div>
					<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.DtuListHeight" scroll="{'group':'a'}">
						<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
							<thead class="head-token">
							<tr>
								<th class="w10x taC"></th>
								<th></th>
								<th class="w14x"></th>
							</tr>
							</thead>
							<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(plant,index) in list" :key="index">
								<td class="taC">
									<span v-if="plant.deviceState==null">--</span>
									<span v-else @click.stop="view(plant)" class="curP">
										<StatusIco :id="plant.deviceState" :type="'device'"></StatusIco>
									</span>
								</td>
								<td>{{stationId?plant.systemName||'--':plant.stationName||"--"}}</td>
								 <td :title="timeFormat(plant.collectionTime,'%Y/%m/%d %H:%M:%S UTC',plant.timeZone)">
									<div>{{timeFormat(plant.collectionTime,'%H:%M:%S',plant.timeZone)}}</div>
									<div class="cSub">{{timeFormat(plant.collectionTime,'%Y/%m/%d UTC',plant.timeZone)}}</div>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<no-result v-show="pagination.total==0"></no-result>
		</div>
		<div class="tableBatch bgContent cSub tra-fast DtuListHeight" :class="{disable:!list.length}">
			<Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
		</div>
	</div>
</template>
<script>
import {getLanguageStr} from "@/util/language"
import * as lib from "@/util/lib.js"
import EditChildSysDevice from '@/view/maintain/part/childSys/EditChildSysDevice.vue'
import StatusIco from "@/components/common/ui/StatusIco.vue"
import Checkbox from "@/components/common/ui/Checkbox.vue"
import Pagination from "@/components/common/ui/Pagination.vue"
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import Confirm from "@/components/common/ui/Confirm.vue";
import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue';
import PlantDetailLight from '@/view/maintain/light/plant/ViewDetail.vue';
import PlantDetailWind from '@/view/maintain/wind/plant/ViewDetail.vue';

import * as apiPlantList from '@/api/maintain/plant/list';
import {apiGetDeviceList} from '@/api/maintain/device/main.js';

export default {
	name: 'DtuList',
	components: {StatusIco,Checkbox,Pagination,NoResult,Loading,Confirm,EditChildSysDevice},
	props:{
		roleCode:{
			type:Array,
			default:()=>{[]}
		},
		stationId:{//指明电站id，将表明在电站详情中使用
			type:Number,
			default:null
		},
		openView:{//是否使用内建的详情
			type:Boolean,
			default:true
		},
		searchKey:{//搜索内容
			type:String,
			default:undefined
		},
		powerTypeList:{//能源类型"PV","WIND"
			type:Array,
			default:undefined
		}
	},
	data() {
		return {
			selectQty:0,
			systemId:null,
			selectAllStatus:0,
			pagination:{page:1,total:0},//分页数据
			stage,
			selectIds:[],
			floatColumn: ["a","a"],
			column: ["1", "2", "3"],
			order:{
				property:'device_sn',
				direction:'ASC'
			},
			lastOrderBy: 'name',
			list:[],
			active:{
				sn:this.searchKey
			},
			level:0,
			ApiName:['OperationCollector','OperationChildCollector'],
			timeOffset:''
		}
	},
	watch:{
		searchKey:function(str){
			this.active.sn=str;
		},
		powerTypeList:function(newValue,oldValue){
			this.getList();
		}
	},
	methods: {
		getLanguageStr,
		getTypeText:lib.getTypeText,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
		operateModeChange:lib.operateModeChange,
		doPermissions:lib.doPermissions,
		clone(arr){
			return _.cloneDeep(arr)
		},
		show(data){
			this.selectQty=0
			this.selectAllStatus=0
			this.timeOffset=data.timeOffset //时区
			this.active=data.status
			this.systemId=data.systemId
			this.level=data.level
			if(data.page)this.$set(this.pagination.request,'page',1)
			this.getList()
		},
		view:function(data){//查看详情
			if(this.openView){
				this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],DeviceDetail,{
					bg:this.stationId?true:false,
					type:1,
					outRoleCode:data.roleCode||this.roleCode
				},{
					Delete:[this.getList.bind(this)]
				},{}).then(({instance,childInstance})=>{
					childInstance.show(data,"",instance);
				});
			}
			else{
				this.$emit("View",data);
			}
		},
		viewPlant:function(data){//打开所属电站的详情
			// trace(data,true)
			// data.id=data.siteId;//电站详情识别id字段
			let plantDetailPart;
			if(this.powerTypeList&&this.powerTypeList.length==1){
				switch(this.powerTypeList[0]){
					case "PV":
						plantDetailPart=PlantDetailLight;
						break;
					case "WIND":
						plantDetailPart=PlantDetailWind;
						break;
				}
			}
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],plantDetailPart,{
				bg:true,
				// outRoleCode:data.roleCode||this.roleCode
			},{
				Delete:[this.getList.bind(this)]
			},{}).then(({instance,childInstance})=>{
				childInstance.show({id:data.siteId},instance);
			});
		},
		timeFormat (sec,format,timeZoneCode=this.timeOffset) {
			let out="";
			if(timeZoneCode){
				out = lib.timeFormat(sec, 'utc', format, {offset:timeZoneCode})
			}else out = lib.timeFormat(sec, 'inc', format)
			return out;
		},
		selectSingle(value,index){
			this.selectData(value,index)
		},
		selectData(val,index){
			if($.type(val)=="boolean"&&index>=0){
				this.list[index].isSelect=val;
			}else if(index=="all"){
				this.list = this.list.map(function(item,index){
					item.isSelect = val;
					return item;
				})
			}
			this.selectQty=this.list.filter(function(e){
				return e.isSelect;
			}).length;
			if(this.selectQty==this.list.length){
				this.selectAllStatus=2;
			}else if(this.selectQty>0){
				this.selectAllStatus=1;
			}else this.selectAllStatus=0;
        },
		getList(){
			this.$refs.Loading.show();
			let pages
			if(this.level==0){
				pages={page:this.pagination.request.page,size:this.pagination.request.size,deviceState:this.active.deviceState,sn:this.active.sn,'order.direction':this.order.direction,'order.property':this.order.property}
			}else{
				pages={page:this.pagination.request.page,size:this.pagination.request.size,deviceState:this.active.deviceState,sn:this.active.sn,systemId:this.systemId,'order.direction':this.order.direction,'order.property':this.order.property}
			}
			if(this.stationId){//在电站详情的场景中
	            apiPlantList.OperationDTU(this.stationId,pages).then(res=>{
					this.list=res.data
					let {total}=res
					this.pagination={...this.pagination,total}
					this.$nextTick(function(){
						lib.fillHeight();
						// lib.setScroll($("#DtuList [scroll]"));
						this.$refs.Loading.hide();
					});
	            },error=>{
					this.$refs.Loading.hide();
	                !_.isEmpty(error) && this.$notify(error)
	            });
			}
			else{//在所有电站下查设备
				apiGetDeviceList("DTU",{...pages,'powerTypeList':this.powerTypeList.join(",")}).then(success=>{
					// trace(success,true)
					this.list=success.data;
					this.pagination.total=success.total;
					this.$nextTick(()=>{
						lib.fillHeight();
						this.$refs.Loading.hide();
					});
				},error=>{
					this.$refs.Loading.hide();
				});
			}
		},
		//排序
		Order(name){
			if(this.lastOrderBy==name){
				if(this.order.direction=='ASC'){
					this.order.direction='DESC'
				}else{
					this.order.direction='ASC'
				}
			}else{
				this.order.direction='ASC'
			}
			this.order.property=name
			this.lastOrderBy=name
			this.getList()
		},
		editDeviceInfo(device){
			this.$refs.editChildSysDevice.modeChange("single");
			this.$refs.editChildSysDevice.show({
				stationId:this.stationId||device.siteId,
				systemId:device.systemId,
				plantName:device.name,
				deviceId:device.id
			});
		},
		multiEditDeviceInfo(){
			let selectIds=[]	//声明选择的项
			this.selectIds=[]	//存放仅id
			selectIds=this.list.filter(function(e){
				return e.isSelect;
			});	//过滤被选项
			selectIds.forEach((val,index)=>{
				this.selectIds[index]=val.id
			})
			this.$refs.editChildSysDevice.modeChange("multi");
            this.$refs.editChildSysDevice.show({
				stationId:this.stationId,
				selectIds:this.selectIds
            })
		},
		confirmDel(device){
			this.$refs.confirm.show({
				text:getLanguageStr('phrase602','确认要删除设备吗?'),
				device
			});
		},
		del(data){
			apiPlantList.OperationDelete(data.device.systemId,[data.device.id]).then(res=>{
				this.getList()
				this.$emit('refreshTree')
				this.$emit("Update");
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		editSuccess(){
			this.getList()
			this.$emit('refreshTree');
			this.$emit("Update");
		}
	},
	computed:{
		moreBtnFlag() {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if(!buttonPermissions.includes('A/B/A9') && !buttonPermissions.includes('A/B/A10')&&!buttonPermissions.includes('A/B/A6') ) {
				return false
			}else {
				return true
			}
		},
	},
	mounted() {
		lib.fillHeight();
		lib.setScroll($(this.$el).find("[scroll]"));
		if(!this.stationId)this.getList();//电站详情的设备列表会执行show来开始运作
	}
}
</script>
<style lang="scss" scoped>
$operateMin:4em + 1;
$operate2x:4em * 2 + 1;
$operate3x:4em * 3 + 1;
.operate{
	&.operate-2x>*{width:$operate2x;}
	&.operate-2x[mode]{width:$operate2x;}
	&.operate-2x[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operate2x);}
	}
	&.operate-3x>*{width:$operate3x;}
	&.operate-3x[mode]{width:$operate3x;}
	&.operate-3x[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operate3x);}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/DtuList.vue